import { WorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateInternalCommentRequest,
  useVbsWorkOrderUpdateInternalCommentMutation,
} from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import {
  errorsFor,
  useErrDocumentNotReady,
} from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import { fieldErrors } from "@/shared/lib/errors/validation-error";
import { TextareaInput } from "@/shared/components/form/textarea-input";
import t from "@/lang/lang";

export function WorkOrderInternalCommentInput({
  workOrder,
  disabled = false,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateInternalCommentRequest>({
    id: workOrder.id,
    internalComment: workOrder.internalComment,
  });
  const mutation = useVbsWorkOrderUpdateInternalCommentMutation();

  const { error } = useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    internalComment: workOrder.internalComment,
  });

  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();

  const errors = [
    ...(errorsFor(notReadyError, "internalComment") ?? []),
    ...(fieldErrors(error, "internalComment") ?? []),
  ];

  return (
    <TextareaInput
      label={t("Interner Kommentar")}
      field="internalComment"
      text={request.internalComment}
      onTextChange={(internalComment) => {
        setRequest({ ...request, internalComment });
        resetNotReadyErrorField("internalComment");
      }}
      errors={errors}
      disabled={disabled}
    />
  );
}
